"use strict";

require("./_fullscreen-image");